import { render } from "./VacancyModalContainer.vue?vue&type=template&id=08214ad7&scoped=true&ts=true&lang=pug"
import script from "./VacancyModalContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./VacancyModalContainer.vue?vue&type=script&setup=true&lang=ts"

import "./VacancyModalContainer.vue?vue&type=style&index=0&id=08214ad7&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08214ad7"]])

export default __exports__